const value = {
    option: 'Option',
    correctAnswersQuizCount: 'Correct answers to quiz',
    correctAnswersPracticeCount: 'Completed tasks',
    correctAnswersTotalCount: 'Total score',
    successResultsTitle: 'Congratulations',
    successResultsSubTitle: "You've passed the task",
    successResultsMessage: 'You are a sec champ',
    failResultsTitle: 'Unfortunately, you did not complete the task',
    failResultsMessage: 'We recommend that you study the theory carefully and try again',
    resultSuccessTitle: 'Well done, you have achieved great results!',
    resultSuccessSubtitle: 'Great job, keep up!',
    resultOkTitle: 'Good result! You answered most of the questions correctly.',
    resultOkSubtitle:
      'Before the next try, pay attention to the questions in which you made mistakes, and study the unit again.',
    resultFailureTitle: "Try again, you don't have enough correct answers to pass the unit.",
    resultFailureSubtitle:
      'Pay attention to the question, analyze them, and review problem areas. Take the quiz or practice portion again to make sure you understand everything correctly.',
    success: 'Success',
    successMessage: 'All the tasks completed',
    neutral: 'Neutral',
    neutralMessage: 'More than one mistake was made and more than 50% of the answers were answered correctly',
    failure: 'Failure',
    failureMessage: 'More than 50% of answers were incorrect',
    quizResultMessage: "{{title}} You've answered {{correctAnswers}} of {{totalQuestions}} questions and got",
  };

export default value;
